import { render, staticRenderFns } from "./RecebimentoItemInstrucoes.vue?vue&type=template&id=45493a65&scoped=true"
import script from "./RecebimentoItemInstrucoes.vue?vue&type=script&lang=ts"
export * from "./RecebimentoItemInstrucoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45493a65",
  null
  
)

export default component.exports